import fadeIn from './base/fade-in'
import text from './base/text'
import title from './base/title'
import VARS from './settings/vars'
import { AnimBase, AnimBaseProps } from './types'

const animBaseTypes: Record<AnimBase, (_props: AnimBaseProps) => void> = {
  'fade-in': (props: AnimBaseProps) => fadeIn(props),
  text: (props: AnimBaseProps) => fadeIn(props),
  title: (props: AnimBaseProps) => text(props)
}

export { animBaseTypes, fadeIn, text, title, VARS }
